var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23348"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20223",
    style: {
      fill: "none"
    },
    d: "M0 0h101v101H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17893",
    d: "m4 54.809 19.417-19.418a8.468 8.468 0 0 1 11.974 0l19.418 19.418m-8.468-8.468 6.715-6.715a8.468 8.468 0 0 1 11.974 0l6.715 6.715m-25.4-25.4h.042M12.468 71.745h50.809a8.468 8.468 0 0 0 8.468-8.468V12.468A8.468 8.468 0 0 0 63.277 4H12.468A8.468 8.468 0 0 0 4 12.468v50.809a8.468 8.468 0 0 0 8.468 8.468z",
    transform: "translate(12.512 12.748)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      fill: "none"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload1);
export default __webpack_public_path__ + "static/media/upload-1.d6c1c2c23b76222221652ab5deec62ab.svg";
export { ForwardRef as ReactComponent };